import { http } from "@/helpers/http";
// const baseUrl = "https://vlb1gj74h8.execute-api.us-east-1.amazonaws.com/dev/v1";
// const baseUrl = "https://3uigucmhaj.execute-api.ap-southeast-1.amazonaws.com/dev/v1"; // sg
// const baseUrl = "http://localhost:3000/dev/v1"; // dev
const baseUrl = "/orders/v1";

export default {
  namespaced: true,
  state: {
    cancelToken: null,
    activeStatus: null,
  },
  getters: {
    activeStatus(state) {
      return state.activeStatus;
    }
  },
  mutations: {
    setActiveStatus(state, activeStatus) {
      state.activeStatus = activeStatus;
    },
    setCancelTokenSource(state, cancelToken) {
      state.cancelTokenSource = cancelToken;
    }
  },

  actions: {

    fetchOrderDetail({ state, commit, rootState }, payload) {
      http
        .get(baseUrl + "/orders/" + payload.id)
        .then((response) => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch((error) => {
          if (payload.callback) payload.callback(false);
        });
    },

    async fetchOrdersReport({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.get(`${baseUrl}/orders/report`, { params: payload.params, responseType: payload.params.format === "csv" ? "text" : null })
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async createOrder({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.post(baseUrl + "/orders", payload.order)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async updateOrder({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.put(baseUrl + "/orders/" + payload.id, payload.order)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    },

    async deleteOrder({ state, commit, rootState }, payload) {
      try {
        const { data } = await http.delete(baseUrl + "/orders/" + payload.id)
        return { status: true, data }
      } catch (e) {
        console.log(e)
        return { status: false }
      }
    }
  },
};

